import {Button} from '@material-ui/core';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import {useField, useFormikContext} from 'formik';
import React, {ReactElement, useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {isFieldRequired, useValidationSchema} from '../../../shared/form/ValidationService';
import {NxFormikProps} from '../../../shared/model/NxComponents.model';
import NxInput, {NxInputProps} from '../nxInput/NxInput';
import styles from './FormikStaticInput.module.scss';

interface StaticInputProps extends Omit<NxInputProps, NxFormikProps> {
  name: string;
}

export default function FormikStaticInput(props: StaticInputProps): ReactElement {

  const context = useFormikContext();
  const [field, meta] = useField(props);
  const validationSchema = useValidationSchema();
  const [key, setKey] = useState<boolean>(false);

  const handleClick = (): void => {
    setKey(true);
    setTimeout(() => {
      setKey(false);
    }, 3000);
  };

  return (
    <div className={styles.staticInputWrapper}>
      <NxInput {...field}
               {...props}
               className={styles.staticInput}
               error={meta.error}
               disabled={props.disabled || context.isSubmitting}
               required={props.required || isFieldRequired(validationSchema, field.name)} />
      <CopyToClipboard text={field.value}>
        <Button className={styles.btnCopy}
                onClick={(): void => handleClick()}
                variant='contained'
                endIcon={!key && <CopyIcon />}>
          {!key ? 'Copy' : 'Copied'}
        </Button>
      </CopyToClipboard>
    </div>
  );
}
